/* ============================================================
   ET - Collection Grid — Regular/Plus toggle + Filters popup
   Client-side, page-wide controller.

   - Operates on every [data-product-card] across every
     .et-collection-grid section on the page.
   - The Regular/Plus toggle and the "Serie Type" facet share one
     state; default shows Regular (cards with data-plus="true" hidden).
   - Facet lists (Serie Type, Color, Handle color, Size, Price) are
     built from the rendered cards, so it adapts to any collection.
   ============================================================ */
(function () {
  if (window.__etColFiltersInit) return;
  window.__etColFiltersInit = true;

  var MOBILE_OPEN_GROUPS = ['serie', 'color']; // groups expanded by default

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-product-card]'));
    if (!cards.length) return;

    // The toggle + Filters button are page-wide controls — keep only the first
    // bar on the page (CSS handles this too; this is the robust fallback).
    var allControls = document.querySelectorAll('[data-plp-controls]');
    for (var ci = 1; ci < allControls.length; ci++) {
      allControls[ci].style.display = 'none';
    }

    // Pull labels from the script tag that loaded us.
    var script =
      document.currentScript ||
      document.querySelector('script[src*="et-collection-filters.js"]');
    var L = (script && script.dataset) || {};
    function label(key, fallback) {
      return (L[key] && L[key].trim()) || fallback;
    }

    // ---- Card model -------------------------------------------------
    function splitVals(str) {
      if (!str) return [];
      return str
        .split('|')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
    }

    var model = cards.map(function (el) {
      return {
        el: el,
        section: el.closest('.et-collection-grid'),
        plus: el.getAttribute('data-plus') === 'true',
        available: el.getAttribute('data-available') === 'true',
        price: parseInt(el.getAttribute('data-price'), 10) || 0, // cents
        colors: splitVals(el.getAttribute('data-colors')),
        handles: splitVals(el.getAttribute('data-handles')),
        size: (el.getAttribute('data-size') || '').trim()
      };
    });

    var prices = model.map(function (m) { return m.price; });
    var priceFloor = Math.floor(Math.min.apply(null, prices) / 100);
    var priceCeil = Math.ceil(Math.max.apply(null, prices) / 100);
    if (!isFinite(priceFloor)) priceFloor = 0;
    if (!isFinite(priceCeil) || priceCeil <= priceFloor) priceCeil = priceFloor + 1;

    // ---- State ------------------------------------------------------
    var state = {
      series: ['regular'], // default: Regular only
      inStock: false,
      colors: [],
      handles: [],
      sizes: [],
      priceMin: priceFloor,
      priceMax: priceCeil
    };

    // Remember which serie (Regular / Plus) was active so that returning
    // to this collection — e.g. browser Back from a product page — restores
    // the previously selected serie instead of falling back to the default.
    // Scoped per collection path, session-lifetime.
    var SERIE_KEY = 'et-serie:' + window.location.pathname;
    function saveSerie() {
      try { window.sessionStorage.setItem(SERIE_KEY, JSON.stringify(state.series)); } catch (e) {}
    }
    function restoreSerie() {
      try {
        var raw = window.sessionStorage.getItem(SERIE_KEY);
        if (!raw) return;
        var saved = JSON.parse(raw);
        if (Array.isArray(saved) && saved.length) state.series = saved;
      } catch (e) {}
    }
    restoreSerie();

    function serieOf(m) { return m.plus ? 'plus' : 'regular'; }
    function hasAny(arr, vals) {
      for (var i = 0; i < vals.length; i++) {
        if (arr.indexOf(vals[i]) !== -1) return true;
      }
      return false;
    }

    // A grid section switched off by the PLP-004 tabs. Its cards stay in the
    // DOM but must not show up, nor count towards any result total.
    // Always false when no tabs are present.
    function groupOff(m) {
      return !!(m.section && m.section.classList.contains('et-plp-group--off'));
    }

    // Match a card against the state, optionally skipping one facet
    // (used to compute facet counts the standard "faceted" way).
    function matches(m, skip) {
      if (groupOff(m)) return false;
      if (skip !== 'serie' && state.series.length && state.series.indexOf(serieOf(m)) === -1) return false;
      if (skip !== 'instock' && state.inStock && !m.available) return false;
      if (skip !== 'color' && state.colors.length && !hasAny(m.colors, state.colors)) return false;
      if (skip !== 'handle' && state.handles.length && !hasAny(m.handles, state.handles)) return false;
      if (skip !== 'size' && state.sizes.length && state.sizes.indexOf(m.size) === -1) return false;
      if (skip !== 'price') {
        var p = m.price / 100;
        if (p < state.priceMin || p > state.priceMax) return false;
      }
      return true;
    }

    function countFor(skip, predicate) {
      var n = 0;
      for (var i = 0; i < model.length; i++) {
        if (matches(model[i], skip) && predicate(model[i])) n++;
      }
      return n;
    }

    // Distinct values (insertion order) across all cards.
    function distinct(getter) {
      var seen = {};
      var out = [];
      model.forEach(function (m) {
        var vals = getter(m);
        if (typeof vals === 'string') vals = vals ? [vals] : [];
        vals.forEach(function (v) {
          if (v && !seen[v]) { seen[v] = 1; out.push(v); }
        });
      });
      return out;
    }

    var colorValues = distinct(function (m) { return m.colors; });
    var handleValues = distinct(function (m) { return m.handles; });
    var sizeValues = distinct(function (m) { return m.size; });
    var hasPlus = model.some(function (m) { return m.plus; });
    var hasRegular = model.some(function (m) { return !m.plus; });

    // ---- Build facet UI --------------------------------------------
    var groupsHosts = Array.prototype.slice.call(document.querySelectorAll('[data-facet-groups]'));
    var drawers = Array.prototype.slice.call(document.querySelectorAll('[data-filters]'));

    function chevron() {
      return '<svg class="et-facet__chev" viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    function checkIcon() {
      return '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true"><path d="M5 12l5 5 9-10" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    function optionRow(facet, value, text) {
      return (
        '<label class="et-facet__opt">' +
          '<input type="checkbox" class="et-facet__input" data-facet="' + facet + '" value="' + escapeAttr(value) + '">' +
          '<span class="et-facet__box">' + checkIcon() + '</span>' +
          '<span class="et-facet__name">' + escapeHtml(text) + ' <span class="et-facet__count" data-count="' + facet + '" data-value="' + escapeAttr(value) + '"></span></span>' +
        '</label>'
      );
    }

    function facetGroup(key, title, openByDefault, innerHtml) {
      var open = openByDefault ? ' is-open' : '';
      var expanded = openByDefault ? 'true' : 'false';
      return (
        '<div class="et-facet' + open + '" data-group="' + key + '">' +
          '<button type="button" class="et-facet__head" data-facet-toggle aria-expanded="' + expanded + '">' +
            '<span class="et-facet__title">' + escapeHtml(title) + '</span>' + chevron() +
          '</button>' +
          '<div class="et-facet__body">' + innerHtml + '</div>' +
        '</div>'
      );
    }

    function buildFacetsHtml() {
      var html = '';

      // Serie Type
      if (hasPlus && hasRegular) {
        var serieRows = '';
        serieRows += optionRow('serie', 'regular', label('regularLabel', 'Regular'));
        serieRows += optionRow('serie', 'plus', label('plusLabel', 'Plus'));
        html += facetGroup('serie', label('serieLabel', 'Serie Type'), MOBILE_OPEN_GROUPS.indexOf('serie') !== -1, serieRows);
      }

      // Color
      if (colorValues.length) {
        var colorRows = colorValues.map(function (v) { return optionRow('color', v, v); }).join('');
        html += facetGroup('color', label('colorLabel', 'Color'), MOBILE_OPEN_GROUPS.indexOf('color') !== -1, colorRows);
      }

      // Price
      var priceInner =
        '<div class="et-price">' +
          '<div class="et-price__fields">' +
            '<div class="et-price__field"><input type="number" class="et-price__num" data-price-min inputmode="numeric" value="' + priceFloor + '"><span class="et-price__cur">' + escapeHtml(label('currency', 'EUR')) + '</span></div>' +
            '<span class="et-price__dash"></span>' +
            '<div class="et-price__field"><input type="number" class="et-price__num" data-price-max inputmode="numeric" value="' + priceCeil + '"><span class="et-price__cur">' + escapeHtml(label('currency', 'EUR')) + '</span></div>' +
          '</div>' +
          '<div class="et-price__slider" data-price-slider>' +
            '<div class="et-price__track"></div>' +
            '<div class="et-price__range" data-price-fill></div>' +
            '<input type="range" class="et-price__handle" data-price-range-min min="' + priceFloor + '" max="' + priceCeil + '" value="' + priceFloor + '">' +
            '<input type="range" class="et-price__handle" data-price-range-max min="' + priceFloor + '" max="' + priceCeil + '" value="' + priceCeil + '">' +
          '</div>' +
        '</div>';
      html += facetGroup('price', label('priceLabel', 'Price'), false, priceInner);

      // Size
      if (sizeValues.length) {
        var sizeRows = sizeValues.map(function (v) { return optionRow('size', v, v); }).join('');
        html += facetGroup('size', label('sizeLabel', 'Size'), false, sizeRows);
      }

      // Handle color
      if (handleValues.length) {
        var handleRows = handleValues.map(function (v) { return optionRow('handle', v, v); }).join('');
        html += facetGroup('handle', label('handleLabel', 'Handle color'), false, handleRows);
      }

      return html;
    }

    var facetsHtml = buildFacetsHtml();
    groupsHosts.forEach(function (host) { host.innerHTML = facetsHtml; });

    // ---- Apply / render --------------------------------------------
    function moneyParts(v) { return v.toLocaleString('nl-NL'); }

    function applyFilters() {
      var visible = 0;
      model.forEach(function (m) {
        var ok = matches(m, null);
        m.el.classList.toggle('et-card--filtered-out', !ok);
        if (ok) visible++;
      });

      // Per-grid empty state
      document.querySelectorAll('.et-collection-grid__grid').forEach(function (grid) {
        var section = grid.closest('.et-collection-grid') || grid.parentNode;
        // Hidden by a tab — leave it alone, it gets recomputed when re-shown.
        if (section && section.classList.contains('et-plp-group--off')) return;
        var anyVisible = grid.querySelector('[data-product-card]:not(.et-card--filtered-out)');
        var msg = section && section.querySelector('[data-grid-no-results]');
        if (msg) msg.hidden = !!anyVisible;
        grid.style.display = anyVisible ? '' : 'none';
      });

      // Counts
      document.querySelectorAll('[data-count]').forEach(function (el) {
        var facet = el.getAttribute('data-count');
        var value = el.getAttribute('data-value');
        var n;
        if (facet === 'serie') {
          n = countFor('serie', function (m) { return serieOf(m) === value; });
        } else if (facet === 'color') {
          n = countFor('color', function (m) { return m.colors.indexOf(value) !== -1; });
        } else if (facet === 'handle') {
          n = countFor('handle', function (m) { return m.handles.indexOf(value) !== -1; });
        } else if (facet === 'size') {
          n = countFor('size', function (m) { return m.size === value; });
        } else {
          n = 0;
        }
        el.textContent = '(' + n + ')';
      });

      // Result count buttons
      document.querySelectorAll('[data-result-count]').forEach(function (el) {
        el.textContent = visible;
      });

      // Mobile product count (e.g. "6 producten")
      var countLabel = label('countLabel', 'producten');
      document.querySelectorAll('[data-plp-count]').forEach(function (el) {
        el.textContent = visible + ' ' + countLabel;
      });

      syncToggles();
      syncSerieChecks();
      syncPriceUI();
      saveSerie();
    }

    // ---- Serie toggle <-> serie facet sync -------------------------
    function syncToggles() {
      var current = state.series.length === 1 ? state.series[0] : null;
      document.querySelectorAll('[data-serie-toggle] [data-serie]').forEach(function (btn) {
        var on = current === btn.getAttribute('data-serie');
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    function syncSerieChecks() {
      document.querySelectorAll('.et-facet__input[data-facet="serie"]').forEach(function (input) {
        input.checked = state.series.indexOf(input.value) !== -1;
      });
    }

    // ---- Price UI sync ---------------------------------------------
    function syncPriceUI() {
      document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
        var minH = slider.querySelector('[data-price-range-min]');
        var maxH = slider.querySelector('[data-price-range-max]');
        var fill = slider.querySelector('[data-price-fill]');
        if (minH) minH.value = state.priceMin;
        if (maxH) maxH.value = state.priceMax;
        if (fill) {
          var span = priceCeil - priceFloor;
          var lo = ((state.priceMin - priceFloor) / span) * 100;
          var hi = ((state.priceMax - priceFloor) / span) * 100;
          fill.style.left = lo + '%';
          fill.style.right = (100 - hi) + '%';
        }
      });
      document.querySelectorAll('[data-price-min]').forEach(function (i) {
        if (document.activeElement !== i) i.value = state.priceMin;
      });
      document.querySelectorAll('[data-price-max]').forEach(function (i) {
        if (document.activeElement !== i) i.value = state.priceMax;
      });
    }

    // ---- Drawer open/close -----------------------------------------
    function openDrawer() {
      drawers.forEach(function (d, i) {
        if (i === 0) {
          d.hidden = false;
          d.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(function () { d.classList.add('is-open'); });
          var panel = d.querySelector('.et-filters__panel');
          if (panel) panel.focus();
        }
      });
      document.documentElement.classList.add('et-filters-open');
    }
    function closeDrawer() {
      drawers.forEach(function (d) {
        d.classList.remove('is-open');
        d.setAttribute('aria-hidden', 'true');
        window.setTimeout(function () { d.hidden = true; }, 250);
      });
      document.documentElement.classList.remove('et-filters-open');
    }

    // ---- Events -----------------------------------------------------
    document.addEventListener('click', function (e) {
      // Serie toggle
      var serieBtn = e.target.closest('[data-serie-toggle] [data-serie]');
      if (serieBtn) {
        state.series = [serieBtn.getAttribute('data-serie')];
        applyFilters();
        return;
      }

      if (e.target.closest('[data-filters-open]')) { openDrawer(); return; }
      if (e.target.closest('[data-filters-close]')) { closeDrawer(); return; }
      if (e.target.closest('[data-filters-apply]')) { closeDrawer(); return; }

      if (e.target.closest('[data-filters-reset]')) {
        state.series = ['regular'];
        state.inStock = false;
        state.colors = [];
        state.handles = [];
        state.sizes = [];
        state.priceMin = priceFloor;
        state.priceMax = priceCeil;
        // reset visible inputs
        document.querySelectorAll('.et-facet__input').forEach(function (i) { i.checked = false; });
        document.querySelectorAll('[data-instock]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); b.classList.remove('is-on'); });
        applyFilters();
        return;
      }

      // In-stock switch
      var sw = e.target.closest('[data-instock]');
      if (sw) {
        state.inStock = sw.getAttribute('aria-checked') !== 'true';
        document.querySelectorAll('[data-instock]').forEach(function (b) {
          b.setAttribute('aria-checked', state.inStock ? 'true' : 'false');
          b.classList.toggle('is-on', state.inStock);
        });
        applyFilters();
        return;
      }

      // Facet group collapse/expand
      var head = e.target.closest('[data-facet-toggle]');
      if (head) {
        var group = head.closest('.et-facet');
        var nowOpen = !group.classList.contains('is-open');
        group.classList.toggle('is-open', nowOpen);
        head.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
        return;
      }
    });

    // Checkbox facets
    document.addEventListener('change', function (e) {
      var input = e.target.closest('.et-facet__input');
      if (!input) return;
      var facet = input.getAttribute('data-facet');
      var value = input.value;
      var key = facet === 'serie' ? 'series'
        : facet === 'color' ? 'colors'
        : facet === 'handle' ? 'handles'
        : facet === 'size' ? 'sizes'
        : null;
      if (!key) return;
      var arr = state[key];
      var idx = arr.indexOf(value);
      if (input.checked && idx === -1) arr.push(value);
      else if (!input.checked && idx !== -1) arr.splice(idx, 1);
      applyFilters();
    });

    // Price numeric inputs
    document.addEventListener('input', function (e) {
      if (e.target.matches('[data-price-min]')) {
        var v = clamp(parseInt(e.target.value, 10), priceFloor, state.priceMax);
        if (!isNaN(v)) { state.priceMin = v; applyFilters(); }
      } else if (e.target.matches('[data-price-max]')) {
        var v2 = clamp(parseInt(e.target.value, 10), state.priceMin, priceCeil);
        if (!isNaN(v2)) { state.priceMax = v2; applyFilters(); }
      } else if (e.target.matches('[data-price-range-min]')) {
        var lo = Math.min(parseInt(e.target.value, 10), state.priceMax);
        state.priceMin = lo; applyFilters();
      } else if (e.target.matches('[data-price-range-max]')) {
        var hi = Math.max(parseInt(e.target.value, 10), state.priceMin);
        state.priceMax = hi; applyFilters();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // PLP-004 tabs changed which grid sections are visible — recount.
    document.addEventListener('et:plp-groups-changed', function () { applyFilters(); });

    function clamp(v, lo, hi) {
      if (isNaN(v)) return v;
      return Math.min(Math.max(v, lo), hi);
    }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function escapeAttr(s) { return escapeHtml(s); }

    // Expose currency label for buildFacetsHtml's price fields
    L.currency = (script && script.dataset && script.dataset.currency) || 'EUR';

    // Initial paint — JS now owns visibility, drop the pre-init guard.
    document.documentElement.classList.add('et-grid-filters-ready');
    applyFilters();
  });
})();
